import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./CustomFormText.module.css";
import LimitedTextField from "../../../../limited-text-field/LimitedTextField";
import { CustomizableProjectPagesService } from "../../../../../../api";
import { useApi } from "../../../../../hooks";
import { CustomTooltip } from "../../../../tooltip";
import { FORM_SUBTYPES } from "../../../form-enum";
import { SectionsContext } from "../../../CustomizableForm";
import DurationRangeDateComputed from "./DurationRangeDateComputed";

export default function CustomFormText({
	block,
	directApply = false,
	editMode,
	customPageId,
	hasEditorRights = false,
	isFilter = false,
	projectId,
	sectionId,
	onGlobalUpdate,
}) {
	const [localValue, setLocalValue] = useState("");
	const customTextRef = useRef(null);
	const {
		currentValue = "",
		maxCharacters,
		minCharacters = 0,
		subtype,
		endId = null,
		startId = null,
	} = block.options;
	const { call: updateCustomPage } = useApi(CustomizableProjectPagesService.updateCustomPage);
	const { updateLocalSection } = useContext(SectionsContext);
	useEffect(() => {
		if (currentValue) {
			setLocalValue(currentValue);
		}
	}, [currentValue]);
	const handleChange = (val) => {
		setLocalValue(val);
		if (directApply && typeof onGlobalUpdate === "function") {
			onGlobalUpdate({ uuid: block.id, value: val });
		}
	};
	const handleSubmit = () => {
		if (!editMode && !directApply) {
			if (localValue.length >= minCharacters && localValue !== currentValue) {
				if (onGlobalUpdate && typeof onGlobalUpdate === "function") {
					onGlobalUpdate({ uuid: block.id, value: localValue });
					updateLocalSection(sectionId, block.id, { currentValue: localValue });
				} else {
					updateCustomPage({ customPageId, projectId }, { uuid: block.id, value: localValue })
						.then(() => {
							updateLocalSection(sectionId, block.id, { currentValue: localValue });
						})
						.catch((err) => {
							console.error(err);
							setLocalValue(currentValue);
						});
				}
			} else {
				setLocalValue(currentValue);
			}
		}
	};
	return (
		<CustomTooltip title={localValue}>
			{!subtype &&
				((hasEditorRights && !block?.readOnly && (
					<div ref={customTextRef} className={styles.container}>
						<LimitedTextField
							fullWidth
							helperTextRight
							multiline
							className={styles.textfield}
							containerClassName={styles.inputContainer}
							data-testid={block?.name}
							disabled={!hasEditorRights && !isFilter}
							error={localValue.length < minCharacters}
							InputProps={styles.inputProps}
							maxLength={maxCharacters}
							rows={26}
							type={block?.type?.toLowerCase() || "text"}
							value={localValue}
							onBlur={handleSubmit}
							onChange={handleChange}
						/>
					</div>
				)) || <div className={styles.text}>{localValue}</div>)}
			{subtype === FORM_SUBTYPES.AUTO_DATE_RANGE_DURATION && (
				<DurationRangeDateComputed endId={endId} startId={startId} />
			)}
		</CustomTooltip>
	);
}
